export default {
  'navbar.home': 'Home',
  'navbar.explore': 'Explore',
  'navbar.favorites': 'Favorites',
  'navbar.messages': 'Messages',
  'navbar.login': 'Login',
  'navbar.register': 'Register',
  'navbar.about': 'About',
  'navbar.how_it_works': 'How it Works',
  'navbar.pricing': 'Pricing',
  'navbar.blog': 'Blog',
  'navbar.support': 'Support',
  'navbar.dashboard': 'Dashboard',
  'navbar.admin': 'Admin',
  'navbar.logout': 'Logout',
  'navbar.brand': 'Pink Paradise',
  'navbar.toggle_theme': 'Toggle theme',
  'navbar.change_language': 'Change language'
};
